import style from './../../adminSect.module.scss';

const NewUserFields = () => {
  const { inputPadding } = style;


  const fields = [
    {
      item: {
        label: 'Email o número de cuenta',
        name: 'emailOrAcc',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese su email o número de cuenta',
          },
        ],
      },
      input: {
        className: inputPadding,
        style: {marginBottom: '1rem'}
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Nombre completo',
        name: 'fullName',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese su nombre',
          },
        ],
      },
      input: {
        className: inputPadding,
        style: {marginBottom: '1rem'}
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: '¿Que tipo de cuenta es?',
        name: 'role',
        rules: [
          {
            required: true,
            message: 'Por favor elegir un tipo de cuenta'
          }
        ]
      },
      radio: [
        {
          value: 'admin',
          label: 'Admin'
        },
        {
          value: 'pharmacy',
          label: 'Farmacia'
        },
        {
          value: 'supplier',
          label: 'Proveedor'
        }
      ],
      inputTag: 'radio'
    },
  ];
  return fields;
};

export default NewUserFields;
